module.exports = __webpack_public_path__ + "img/withdrawal.d37818af.png";